import { FaClock } from 'react-icons/fa'
import styled, { ThemeProps } from 'styled-components'

type Props = {
  timeLeft: number
}

type DeliveryWindowProps = Props & ThemeProps<any>

const DeliveryWindow = styled.div<DeliveryWindowProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.grey.dark};
  ${({ theme }) => theme.typography.s.normal};

  svg {
    margin-right: 5px;
    height: 16px;
    width: 16px;
    fill: ${(props) => {
      if (props.timeLeft < 6 * 60 * 60 * 1000) {
        // check if time left is less than 6 hours
        return `${props.theme.colors.error.neutral}`
      } else if (props.timeLeft < 12 * 60 * 60 * 1000) {
        // check if time left is less than 12 hours
        return `${props.theme.colors.warning.neutral}`
      } else {
        return `${props.theme.colors.success.neutral}` // green
      }
    }};
  }
}`

const DeliveryText = ({ timeLeft }: Props) => {
  const hours = Math.floor(timeLeft / (60 * 60 * 1000))
  const minutes = Math.round((timeLeft % (60 * 60 * 1000)) / (60 * 1000))

  return (
    <DeliveryWindow timeLeft={timeLeft}>
      <FaClock />
      {hours}h {minutes}m left
    </DeliveryWindow>
  )
}

export const DeliveryTextIcon = ({ timeLeft }: Props) => {
  const hours = Math.floor(timeLeft / (60 * 60 * 1000))
  const minutes = Math.round((timeLeft % (60 * 60 * 1000)) / (60 * 1000))

  return (
    <DeliveryWindow timeLeft={timeLeft}>
      {hours}h {minutes}m left
    </DeliveryWindow>
  )
}

export default DeliveryText
